import { Navigate } from "react-router";
import { useGetProviderQuery } from "../../../apis/Provider.api";
import { PrimaryProvider, Provider } from "../../../types/models/Provider";
import GradientCircularProgress from "../../../../share/components/progress/GradientCircularProgress";

export const ProviderScoped = () => {
    const {
        data,
    } = useGetProviderQuery(PrimaryProvider.fromPath('scoped'))

    if (data) {
        const url = `/dashboard/providers/${data.id}?scoped=true`
        return <Navigate to={url} replace/>
    } else {
        return <>
            <GradientCircularProgress/>
        </>
    }
}
export default ProviderScoped;
